enum PrescriptionStatusEnum {
    InWork = 1,
    Done,
    Accepted,
    PostponementApproval,
    Created,
    Cancelled,
    Rejected,
}

export default PrescriptionStatusEnum;
